import { useLayoutEffect } from "react";
import {Layout} from "../../components/common/Layout"
import { AddCompanyTabs } from "../../components/companies/add/tabs/AddCompanyTabs";

export const AddCompanyPage = () => {

    const title = "Клиенты";
    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white"
        document.body.style.backgroundImage = "";
   });
    return (
        <Layout title={title}>
            <AddCompanyTabs />
        </Layout>
    )
}